import PropTypes from 'prop-types';
import './ErrorMessage.css';

/**
 * ErrorMessage Component
 * 
 * Displays error messages with optional retry action.
 * 
 * @param {string} message - Error message
 * @param {function} onRetry - Optional retry callback
 * @param {function} onDismiss - Optional dismiss callback
 */
export default function ErrorMessage({
  message,
  onRetry,
  onDismiss
}) {
  return (
    <div className="error-message" role="alert">
      <div className="error-icon">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>
      
      <div className="error-content">
        <p className="error-text">{message}</p>
        
        {(onRetry || onDismiss) && (
          <div className="error-actions">
            {onRetry && (
              <button className="error-button error-button-retry" onClick={onRetry}>
                Try Again
              </button>
            )}
            {onDismiss && (
              <button className="error-button error-button-dismiss" onClick={onDismiss}>
                Dismiss
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
  onRetry: PropTypes.func,
  onDismiss: PropTypes.func
};
